export default "__VITE_ASSET__tUFlTnvH__"